import { render, staticRenderFns } from "./HistorySouthData.vue?vue&type=template&id=bbd197ee"
import script from "./HistorySouthData.vue?vue&type=script&lang=js"
export * from "./HistorySouthData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports